import { ApiPlugin, ApiPrivatePlugin } from '@/plugins';
import { cookie } from '@/helpers';

export default class FeedbackService {
  static async getFeedbackForm(webformId) {
    try {
      const response = await ApiPlugin.get(
        `/webform_rest/${webformId}/fields`,
      );
      return response.data;
    } catch (e) {
      console.error('Error fetching articles \n', e);
      return [];
    }
  }

  static async postFeedback(data) {
    const formData = {
      webform_id: data.form_id,
      helpful: data.helpful,
      research_reason: data.research_reason,
      other: data.other,
      url_content: data.url_content,
    };

    if (!cookie.getCookie('token') || cookie.getCookie('token') === '') await this.getAPIToken();

    try {
      const response = await ApiPrivatePlugin().post(
        '/webform_rest/submit',
        JSON.stringify(formData),
      );
      return [response.data];
    } catch (e) {
      console.error('Error posting question \n', e);
      return [];
    }
  }

  static async getAPIToken() {
    try {
      const response = await ApiPlugin.get(
        '/session/token?_format=json',
      );
      cookie.setCookie('token', response.data.trim());
      return true;
    } catch (e) {
      console.error('Error fetching fresh token \n', e);
      return false;
    }
  }
}
